import { render } from "./Sparks.vue?vue&type=template&id=01402b87"
import script from "./Sparks.vue?vue&type=script&lang=js"
export * from "./Sparks.vue?vue&type=script&lang=js"

import "./Sparks.vue?vue&type=style&index=0&id=01402b87&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/Icons/Sparks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01402b87"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01402b87', __exports__)) {
    api.reload('01402b87', __exports__)
  }
  
  module.hot.accept("./Sparks.vue?vue&type=template&id=01402b87", () => {
    api.rerender('01402b87', render)
  })

}


export default __exports__